import { DEFAULT_CHIP_COLOR } from "~/constants/style";
import { USER_KIND_USER } from "~/constants/userKinds";
import { AiModel, EventActor, FolderSort, Language, TaskDetailMode, Theme, UserRole, UserStatus } from "~/shared/enums";
import type { User } from "~/shared/types";

const STANDARD_PSEUDO_USER_PARTIAL = {
  status: UserStatus.ACTIVE,
  role: UserRole.MEMBER,
  theme: Theme.SYSTEM_DEFAULT,
  imageUrl: null,
  timezone: "America/Los_Angeles",
  calendarDuid: null,
  webhookDuid: null,
  workflows: [],
  agentConfig: {},
  taskDetailMode: TaskDetailMode.RIGHTBAR,
  sections: { expanded: [], collapsed: [] },
  layout: {
    rightbarWidthPx: 650,
    leftbarWidthPx: 225,
    fullscreenRightbarWidthPx: 600,
    chatPanelWidthPx: 400,
    docSort: FolderSort.ORDER,
  },
  tutorialStatuses: {},
  authToken: null,
  googleData: null,
  isAdmin: false,
  aiLanguage: Language.ENGLISH,
  aiModel: AiModel.GPT_4_1,
  jobDescription: "",
  aiGuidelines: "",
};

export const FORM_USER_PSEUDO_USER_KEY = "@FormUser";
export const FORM_USER_DISPLAY_VALUE = EventActor.FORM_USER;
export const FORM_USER_PSEUDO_USER: User = {
  duid: FORM_USER_PSEUDO_USER_KEY,
  email: FORM_USER_PSEUDO_USER_KEY,
  name: FORM_USER_DISPLAY_VALUE,
  colorHex: DEFAULT_CHIP_COLOR,
  ...STANDARD_PSEUDO_USER_PARTIAL,
  kind: USER_KIND_USER,
};

export const ORDERED_ROLES = [
  UserRole.FINANCIAL_ADMIN,
  UserRole.TECHNICAL_ADMIN,
  UserRole.GUEST,
  UserRole.MEMBER,
  UserRole.ADMIN,
];
if (ORDERED_ROLES.length !== Object.values(UserRole).length) {
  throw new Error("ORDERED_ROLES length does not match UserRole length");
}
